export const cliente: any = {
    'ifc_maravilhas':{
        nomeCliente: 'Igreja Formosa de Cristo'
        ,instagram: '@ifc_maravilhas'
        ,avatar: require('@/assets/images/avatar-ifcmaravilhas.jpg')
        ,template:{
            bg_pagina: {
                image: 'background-app-shop-dark.jpg'
                ,background: 'rgb(255,227,223)'
                ,gradient: 'linear-gradient(180deg, rgba(255,227,223,1) 0%, rgba(255,255,255,1) 65%)'
            }
        }
        ,social:[
            { 
                thumbnail: ''
                ,alt: 'Facebook'
                ,link: 'https://fb.com/igrejafc'
            }
            ,{ 
                thumbnail: ''
                ,alt: 'Instagram'
                ,link: 'https://instagram.com/ifc_maravilhas'
            },
            { 
                thumbnail: ''
                ,alt: 'Youtube'
                ,link: 'https://youtube.com/ifcmaravilhas'
            }
        ]
        ,items:[
            {
                titulo: 'Culto de Domingo | 08/08 - 09h'
                ,link: 'https://www.eventbrite.com.br/e/culto-de-domingo-0808-09h-tickets-166385346049'
                ,flag: {
                    texto: 'RESERVE O SEU LUGAR'
                    ,color: '#2d7500'
                    ,bg: 'rgba(45, 117, 0, 0.2)'
                }
                ,thumbnail: {
                    bg: '#dffffb'
                    ,color: '#007565'
                    ,icone: 'fas fa-praying-hands'
                }
                ,expiriesDate: '2021-08-08T11:15:00'
                ,type: 'link'
                ,order: 1
            },
            {
                titulo: 'Sexta Básica para Casais | CADASTRO'
                ,link: 'https://forms.gle/wQXHndohL4aguFgr8'
                ,flag: {
                    texto: 'SEXTA 27/08 - 19H'
                    ,color: '#fff'
                    ,bg: '#00b188'
                }
                ,thumbnail: {
                    bg: '#00ce9e'
                    ,color: '#FFF'
                    ,icone: 'icon fas fa-users'
                }
                ,expiriesDate: '2021-08-27T21:30:00'
                ,type: 'link'
            },
            {
                titulo: 'Familiarizando - Novembro | CADASTRO'
                ,link: 'https://docs.google.com/forms/d/e/1FAIpQLSddmr_olkfULxOCCIcvmFCXCDBH5HvNOK_55yZk8GgMNkSk2g/viewform?usp=sf_link&utm_source=connect4sell'
                // ,flag: {
                //     texto: 'ATÉ DOMINGO 10/01'
                //     ,color: '#fff'
                //     ,bg: '#00b188'
                // }
                ,thumbnail: {
                    bg: '#00ce9e'
                    ,color: '#FFF'
                    ,icone: 'icon fas fa-users'
                }
                ,expiriesDate: '2021-11-05T21:30:00'
                ,type: 'link'
            },
            {
                titulo: 'Planner Devocional | LANÇAMENTO'
                ,link: 'https://pag.ae/7WKPFwQ7P?utm_source=connect4sell'
                ,flag: {
                    texto: 'SEM FRETE | 30% DE DESCONTO'
                    ,color: '#111'
                    ,bg: '#dadada'
                }
                ,thumbnail: {
                    bg: '#ffd400'
                    ,color: '#423700'
                    ,icone: 'icon fas fa-book'
                }
                ,type: 'link'
            }
            // ,{
            //     titulo: 'Planner Devocional | LANÇAMENTO'
            //     ,link: 'https://pag.ae/7WKPHgrhN?utm_source=connect4sell'
            //     ,flag: {
            //         texto: 'COM FRETE | 30% DE DESCONTO'
            //         ,color: '#111'
            //         ,bg: '#dadada'
            //     }
            //     ,thumbnail: {
            //         bg: '#ffd400'
            //         ,color: '#423700'
            //         ,icone: 'icon fas fa-book'
            //     }
            //     ,type: 'link'
            // }
            ,{
                titulo: 'Inscreva-se no nosso canal'
                ,link: 'https://bit.ly/2RIAC3F'
                ,thumbnail: {
                    bg: '#fff2f2'
                    ,color: '#f73a3a'
                    ,icone: 'fab fa-youtube'
                }
                ,type: 'link'
                ,order: 4
            }
            ,{
                titulo: 'Curta nossa página no Facebook'
                ,link: 'https://bit.ly/3bKPjKp'
                
                ,thumbnail: {
                    bg: '#ebf2ff'
                    ,color: '#3a74f7'
                    ,icone: 'fab fa-facebook'
                }
                ,type: 'link'
                ,order: 5
            }

        ]
    }
    ,'nathaliaduraes_':{
        nomeCliente: 'Nathalia Durães'
        ,slug: 'nathaliaduraes_'
        ,instagram: '@nathaliaduraes_'
        ,avatar: require('@/assets/images/avatar-nathaliaduraes_.jpg')
        ,social:[
            { 
                thumbnail: ''
                ,alt: 'Facebook'
                ,link: 'https://fb.com/igrejafc'
            }
            ,{ 
                thumbnail: ''
                ,alt: 'Instagram'
                ,link: 'https://instagram.com/ifc_maravilhas'
            },
            { 
                thumbnail: ''
                ,alt: 'Youtube'
                ,link: 'https://youtube.com/ifcmaravilhas'
            }
        ]
        ,template:{
            bg_pagina: {
                image: 'background-app-shop.jpg'
                ,background: 'rgb(255,227,223)'
                ,gradient: 'linear-gradient(180deg, rgba(255,227,223,1) 0%, rgba(255,255,255,1) 65%)'
            }
        }
        ,items:[
            {
                titulo: 'Cantinho da Maria Joana'
                ,link: 'https://google.com'
                ,thumbnail: {
                    bg: '#fff2f2'
                    ,color: '#f73a3a'
                    ,icone: 'fas fa-home'
                }
                ,type: 'link'
                ,order: 1
            }
            ,{
                titulo: 'Meu canal'
                ,link: 'https://youtube.com'
                ,thumbnail: {
                    bg: '#fff9f1'
                    ,color: '#f49517'
                    ,icone: 'fab fa-youtube'
                }
                ,type: 'link'
                ,order: 4
            }
            ,{
                titulo: 'Meu blog'
                ,link: 'https://blog.com'
                ,thumbnail: {
                    bg: '#edffec'
                    ,color: '#1ed613'
                    ,icone: 'fas fa-book'
                }
                ,type: 'link'
                ,order: 3
            }
            ,{
                titulo: 'Produtos'
                ,link: null
                ,thumbnail: {
                    bg: '#eefbff'
                    ,color: '#04a7d8'
                    ,icone: 'fas fa-store'
                }
                ,type: 'accordion'
                ,order: 2
                ,produtos: [
                    {
                        nome: 'Adidas preta'
                        ,variacoes: [
                            {
                                titulo: 'P'
                                ,qtd: 1
                            }
                            ,{
                                titulo: 'PP'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'M'
                                ,qtd: 1
                            }
                            ,{
                                titulo: 'G'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'GG'
                                ,qtd: 1
                            }
                            ,{
                                titulo: 'XG'
                                ,qtd: 1
                            }
                            ,{
                                titulo: 'XGG'
                                ,qtd: 1
                            }
                        ]
                        ,descricao: 'auihd iahsdiuashdiu ahsdiu hasiud hasiu dhaisuhisauhd iaush iaushdiuash iduahsiu dhaisudhi uashdad'
                        ,preco: 36.74
                        ,imagens: [
                            'camiseta-preta.jpg'
                            ,'camiseta-preta-costas.jpg'
                        ]
                        ,thumb: 'camiseta-preta.jpg'
                        ,btnAction: 'COMPRAR'
                        ,features:[
                            {
                                titulo: 'Características'
                                ,texto: 'Básica e versátil, a Camiseta Adidas D2M Soft Logo é ideal para te acompanhar na rua ou treinos em grande estilo. Confeccionada em material leve e macio, garantindo conforto no seu sportwear.'
                            }
                            ,{
                                titulo: 'Garantia'
                                ,texto: '15 dias após confirmação do pagamento.'
                            }
                        ]
                    }
                    ,{
                        nome: 'Adidas preta'
                        ,variacoes: [
                            {
                                titulo: 'P'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'PP'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'M'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'G'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'GG'
                                ,qtd: 10
                            }
                        ]
                        ,descricao: 'auihd iahsdiuashdiu ahsdiu hasiud hasiu dhaisuhisauhd iaush iaushdiuash iduahsiu dhaisudhi uashdad'
                        ,preco: 26.74
                        ,imagens: [
                            'camiseta-preta.jpg'
                            ,'camiseta-preta-costas.jpg'
                        ]
                        ,thumb: 'camiseta-preta.jpg'
                        ,btnAction: 'COMPRAR'
                        ,features:[
                            {
                                titulo: 'Características'
                                ,texto: 'Básica e versátil, a Camiseta Adidas D2M Soft Logo é ideal para te acompanhar na rua ou treinos em grande estilo. Confeccionada em material leve e macio, garantindo conforto no seu sportwear.'
                            }
                            ,{
                                titulo: 'Garantia'
                                ,texto: '15 dias após confirmação do pagamento.'
                            }
                        ]
                    }
                    ,{
                        nome: 'Adidas cinza'
                        ,variacoes: [
                            {
                                titulo: 'P'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'PP'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'M'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'G'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'GG'
                                ,qtd: 10
                            }
                        ]
                        ,descricao: 'auihd iahsdiuashdiu ahsdiu hasiud hasiu dhaisuhisauhd iaush iaushdiuash iduahsiu dhaisudhi uashdad'
                        ,preco: 46.74
                        ,imagens: [
                            'camiseta-cinza.jpg'
                            ,'camiseta-cinza-costas.jpg'
                            ,'camiseta-cinza-detalhe.jpg'
                        ]
                        ,thumb: 'camiseta-cinza.jpg'
                        ,btnAction: 'COMPRAR'
                        ,features:[
                            {
                                titulo: 'Características'
                                ,texto: 'Básica e versátil, a Camiseta Adidas D2M Soft Logo é ideal para te acompanhar na rua ou treinos em grande estilo. Confeccionada em material leve e macio, garantindo conforto no seu sportwear.'
                            }
                            ,{
                                titulo: 'Garantia'
                                ,texto: '15 dias após confirmação do pagamento.'
                            }
                        ]
                    }
                    ,{
                        nome: 'Adidas cinza'
                        ,variacoes: [
                            {
                                titulo: 'P'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'PP'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'M'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'G'
                                ,qtd: 10
                            }
                            ,{
                                titulo: 'GG'
                                ,qtd: 10
                            }
                        ]
                        ,descricao: 'auihd iahsdiuashdiu ahsdiu hasiud hasiu dhaisuhisauhd iaush iaushdiuash iduahsiu dhaisudhi uashdad'
                        ,preco: 56.74
                        ,imagens: [
                            'camiseta-cinza.jpg'
                            ,'camiseta-cinza-costas.jpg'
                            ,'camiseta-cinza-detalhe.jpg'
                        ]
                        ,thumb: 'camiseta-cinza.jpg'
                        ,btnAction: 'COMPRAR'
                        ,features:[
                            {
                                titulo: 'Características'
                                ,texto: 'Básica e versátil, a Camiseta Adidas D2M Soft Logo é ideal para te acompanhar na rua ou treinos em grande estilo. Confeccionada em material leve e macio, garantindo conforto no seu sportwear.'
                            }
                            ,{
                                titulo: 'Garantia'
                                ,texto: '15 dias após confirmação do pagamento.'
                            }
                        ]
                    }
                ]
            }
        ]
    }
}
